import React from 'react';
import { useTranslation } from 'react-i18next';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import EmptyState from '../../../../../components/empty-state/EmptyState';

function EmptySearchResults() {
  const { t } = useTranslation('settings');

  return (
    <EmptyState
      icon={<Inventory2OutlinedIcon />}
      title={t('noDeletedMedia')}
      description={t('noDeletedMediaDescription')}
    />
  );
}

export default EmptySearchResults;
